import React, { useState } from "react";

import { ChevronDown, ChevronRight } from "lucide-react";

const FAQ_ENTRIES = [
  {
    question: "What is the Freshpaint AI Feature?",
    answer:
      "The AI Feature allows users to analyze, transform, or generate insights from data using advanced language models (currently Anthropic Claude).",
  },
  {
    question: "Does Freshpaint have a BAA for AI?",
    answer:
      "Yes. Freshpaint maintains a Business Associate Agreement (BAA) with its AI provider to support compliant handling of protected data.",
  },
  {
    question: "Is it safe to use PHI with the AI Feature?",
    answer:
      "Yes, when used in accordance with your organization\u2019s compliance policies and applicable laws. Customers should follow the minimum necessary standard and validate outputs.",
  },
  {
    question: "Is customer data used to train AI models?",
    answer:
      "No. Data submitted through the AI Feature is not used to train or improve the underlying AI models.",
  },
  {
    question: "Where is data processed?",
    answer:
      "Data is securely transmitted to and processed by Freshpaint\u2019s AI subprocessor (Anthropic) under contractual privacy and security obligations.",
  },
  {
    question: "Can AI outputs be trusted?",
    answer:
      "AI outputs may be inaccurate or incomplete and should always be reviewed by a human before use.",
  },
  {
    question: "Does the AI provide medical or legal advice?",
    answer:
      "No. The AI Feature is not a substitute for professional judgment or advice.",
  },
  {
    question: "Can we disable the AI Feature?",
    answer: "Yes. The feature is optional and can be disabled at any time.",
  },
  {
    question: "Who is responsible for compliance?",
    answer:
      "Customers are responsible for ensuring appropriate use, including what data is submitted and how outputs are used.",
  },
  {
    question: "Do we need to update our existing contract or Terms of Service?",
    answer:
      "No. The Freshpaint AI Feature is covered under your existing agreement with Freshpaint, and no updates to your Terms of Service are required. Enabling the feature constitutes acceptance of the applicable terms for its use.",
  },
] as const;

export { FAQ_ENTRIES };

export default function AiChatApprovalFaq() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="mt-6">
      <button
        type="button"
        className="flex cursor-pointer items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-800"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        {isOpen ? (
          <ChevronDown className="h-4 w-4" />
        ) : (
          <ChevronRight className="h-4 w-4" />
        )}
        Frequently Asked Questions
      </button>

      {isOpen && (
        <dl className="mt-3 space-y-3">
          {FAQ_ENTRIES.map((entry) => (
            <div key={entry.question}>
              <dt className="text-textHighEmphasis text-sm font-medium">
                {entry.question}
              </dt>
              <dd className="text-textSubtle mt-0.5 text-sm">{entry.answer}</dd>
            </div>
          ))}
        </dl>
      )}
    </div>
  );
}
